import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import {
  ACTION_ADD,
  ACTION_INIT,
  ACTION_REMOVE,
  UPDATE,
} from './const';
import Repo from './repo';
import {
  Item,
  Items,
  Providers,
  RootState,
  State,
} from './types';

const createModule = ({ $config }: Providers) => {

  let storage;
  try {
    storage = localStorage;
  } catch (e) {}
  const repo = new Repo($config.eventDeferred.localStorageKey, storage);

  @Module({
    namespaced: true,
    stateFactory: true,
  })
  class DeferredStore extends VuexModule<State, RootState> {
    // State
    items: Items = [];
    ready: boolean = false;

    // Mutations
    @Mutation
    [UPDATE](items: Items) {
      this.ready = true;
      this.items = items;
    }

    // Actions
    @Action({ commit: UPDATE })
    async [ACTION_ADD](item: Item) {
      return repo.add(item);
    }

    @Action({ commit: UPDATE })
    async [ACTION_INIT]() {
      return repo.load();
    }

    @Action({ commit: UPDATE })
    async [ACTION_REMOVE](id: Item['id']) {
      return repo.remove(id);
    }
  }

  return DeferredStore;
}

export default createModule;



// WEBPACK FOOTER //
// ./src/store/deferred/store.ts